"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPermissionLabel = formatPermissionLabel;
exports.formatRoleLabel = formatRoleLabel;
exports.groupPermissionsByResource = groupPermissionsByResource;
function formatPermissionLabel(permission) {
    return permission
        .split("_")
        .map(function (word) { return word.charAt(0).toUpperCase() + word.slice(1); })
        .join(" ");
}
function formatRoleLabel(role) {
    return role
        .split("_")
        .map(function (word) { return word.charAt(0).toUpperCase() + word.slice(1); })
        .join(" ");
}
function groupPermissionsByResource(permissionKeys) {
    var grouped = permissionKeys.reduce(function (accumulator, permission) {
        var _a = permission.split("_"), resourceParts = _a.slice(1);
        var resourceKey = resourceParts.join("_") || "general";
        if (!accumulator[resourceKey]) {
            accumulator[resourceKey] = [];
        }
        accumulator[resourceKey].push(permission);
        return accumulator;
    }, {});
    return Object.entries(grouped)
        .map(function (_a) {
        var resource = _a[0], permissions = _a[1];
        return ({
            resource: resource,
            permissions: __spreadArray([], permissions, true).sort(),
        });
    })
        .sort(function (a, b) { return a.resource.localeCompare(b.resource); });
}
